import React from 'react';
import { useIntl } from 'react-intl';
import keyLogo from '../images/key-logo.svg';

import messages from './PasskeyLoginPanel.messages';
import {
  SocialLoginOptionWrapper,
  SocialLoginButton,
  SocialLoginButtonRowGroup,
  SocialLoginPanelWrapper,
} from './SocialLoginPanel';

export interface Props {
  handlePasskeyLogin: () => void;
  authenticating?: boolean;
}

export const PasskeyLoginPanel: React.FunctionComponent<Props> = ({
  handlePasskeyLogin,
  authenticating = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <SocialLoginPanelWrapper
      role="list"
      data-i18n-or={formatMessage(messages.passkeyAuthOrLoginWith)}
      data-i18n-continue={formatMessage(messages.passkeyAuthOrLoginWith)}
      className="passkey-login"
      data-testid="passkey-login-wrapper-idf-testid">
      <SocialLoginButtonRowGroup data-testid="passkey-login-idf-testid">
        <SocialLoginOptionWrapper>
          <SocialLoginButton
            id="passkey-auth-button"
            advisoryEnabled={false}
            isLoading={authenticating}
            logo={keyLogo}
            onClick={handlePasskeyLogin}>
            Passkey
          </SocialLoginButton>
        </SocialLoginOptionWrapper>
      </SocialLoginButtonRowGroup>
    </SocialLoginPanelWrapper>
  );
};

export default PasskeyLoginPanel;
